import {Injectable} from '@angular/core';
import {addDoc, collection, deleteDoc, doc, Firestore, getDoc, setDoc} from '@angular/fire/firestore';
import {from, Observable} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class CollectionAdminFunctionsService {

  constructor(private firestore: Firestore) {
  }

  addDocumentToCollection<DataType>(path: string, data: DataType): Observable<void> {
    return from(
      new Promise<void>((resolve, reject) => {
        const collectionRef = collection(this.firestore, path);
        addDoc(collectionRef, data)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      }),
    );
  }

  async setDocument<DataType>(
    path: string,
    data: DataType,
  ): Promise<void> {
    try {
      const docRef = doc(this.firestore, path);
      await setDoc(docRef, data, {merge: true});
    } catch (error) {
      console.error(error);
    }
  }

  async getDocument<DataType>(
    path: string,
  ): Promise<DataType> {
    try {
      const docRef = doc(this.firestore, path);
      const docSnapshot = await getDoc(docRef);
      if (docSnapshot.exists()) {
        return docSnapshot.data() as DataType;
      } else {
        return undefined;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async deleteDocument<DataType>(
    path: string,
  ): Promise<void> {
    try {
      const docRef = doc(this.firestore, path);
      await deleteDoc(docRef);
    } catch (error) {
      console.error(`Error deleting document at path: ${path}\n`, error);
    }
  }


}
